import React from 'react';
import PropTypes from 'prop-types';
import ExtendedAvatar from 'components/extendedAvatar/extended-avatar';

const getStyleSize = (styleSize) => {
  let style = 'bhp-medium';

  switch (styleSize) {
  case 'default':
    style = 'bhp-default';
    break;

  case 'small':
    style = 'bhp-small';
    break;

  case 'large':
    style = 'bhp-large';
    break;

  default:
    break;
  }
  return style;
};
const getStyleDirection = (styleDirection) => {
  let style = 'bhp-vertical';

  switch (styleDirection) {
  case 'vertical':
    style = 'bhp-vertical';
    break;

  case 'horizontal':
    style = 'bhp-horizontal';
    break;

  default:
    break;
  }
  return style;
};
const UserProfile = ({
  name, imageUrl, size, direction, nameClass
}) => {
  const styleSize = getStyleSize(size);
  const styleDirection = getStyleDirection(direction);

  return (
    <div className={`bhp-user-profile ${styleDirection} ${styleSize}`}>
      <ExtendedAvatar src={imageUrl} name={name} />
      <div className="bhp-user-name">
        <span className={nameClass}>{name}</span>
      </div>
    </div>
  );
};

UserProfile.propTypes = {
  imageUrl: PropTypes.string,
  name: PropTypes.string,
  size: PropTypes.string,
  direction: PropTypes.string,
  nameClass: PropTypes.string
};

UserProfile.defaultProps = {
  imageUrl: null,
  name: 'Unknown User',
  size: 'default',
  direction: 'vertical',
  nameClass: 'bhp-title-2'
};

export default UserProfile;
